import { TDispatch, TGetState } from 'state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { fetchHighlightTagsConfig as setHighlightTagsFeatureFlag } from '.';

const ENGLISH_LANGUAGES = ['en', 'en_GB'];
const ADMIN_PANEL_NAMESPACE = 'admin-panel';

const fetchHighlightTagsConfig = (spotId: string, spotLanguage: string) => {
  return async (dispatch: TDispatch, getState: TGetState): Promise<void> => {
    try {
      if (!ENGLISH_LANGUAGES.includes(spotLanguage)) {
        dispatch(
          setHighlightTagsFeatureFlag({
            isHighlightTagsEnabled: false
          })
        );
        return;
      }

      // We removed the Feature flag check for now because it was making calls directly to the DB
      // const { tenant: configResults } = await getHighlightTagsConfig(spotId);

      dispatch(
        setHighlightTagsFeatureFlag({
          isHighlightTagsEnabled: true
        })
      );
    } catch (error) {
      dispatch(
        setHighlightTagsFeatureFlag({
          isHighlightTagsEnabled: false
        })
      );
      console.error(error);
      ErrorNotifier.notifyError(`Failed to fetch highlight tags config`, { spotId });
    }
  };
};

export default fetchHighlightTagsConfig;
